type RuntimeEnvWindow = Window &
  typeof globalThis & {
    __ENV?: Record<string, string | undefined>;
  };

function getWindowRuntimeEnvValue(key: string): string {
  if (typeof window === "undefined") {
    return "";
  }

  return (window as RuntimeEnvWindow).__ENV?.[key] || "";
}

export function getRuntimeEnvValue(key: string): string {
  return process.env[key] || getWindowRuntimeEnvValue(key) || "";
}
